import { z } from 'zod';

export const ProcessMeetingJobApiSchema = z.object({
  meetingUrl: z.string().url()
});

export type ProcessMeetingJobApi = z.infer<typeof ProcessMeetingJobApiSchema>
